"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicesApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function servicesApiClient(networkClient) {
    return {
        getOpenAISeedKeywords: async (query) => {
            return networkClient.getHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/openai/seeds`, query);
        },
        getOpenAITargetingKeywords: async (query) => {
            return networkClient.getHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/openai/targeting-keywords`, query);
        },
        getOpenAIChatCompletions: async (body) => {
            return networkClient.postHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/openai/chat`, body);
        },
        listCalendars: async () => {
            return networkClient.getHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/calendars`);
        },
        listCalendarEvents: async (params) => {
            return networkClient.getHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/calendars/${params.calendarId}/events`);
        },
        addCalendars: async (body) => {
            return networkClient.postHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/calendars/add`, body);
        },
        addCalendarEvents: async (params, body) => {
            return networkClient.postHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/calendars/${params.calendarId}/events/add`, body);
        },
        addCalendarAndEvents: async (body) => {
            return networkClient.postHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/calendars/import`, body);
        },
        deleteCalendar: async (params) => {
            return networkClient.deleteHttp(data_lib_1.SERVICES_WEB_SERVICE, `/api/v2/services/calendars/${params.calendarId}`);
        },
    };
}
exports.servicesApiClient = servicesApiClient;
